const VERIFY_CVV_PREFIX = "verify_cvv";

export const VERIFY_CVV_TEST_IDS = {
    cvvHeading: `${VERIFY_CVV_PREFIX}_heading`,
    cvvTitle: `${VERIFY_CVV_PREFIX}_title`,
    cvvSubTitle: `${VERIFY_CVV_PREFIX}_subTitle`,
    cvvInput: `${VERIFY_CVV_PREFIX}_input`,
    primaryAction: `${VERIFY_CVV_PREFIX}_primary_action`,
};
